import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * Estimated Delivery Component
 * Handles the expand/collapse functionality for estimated delivery details
 * and updates when variant changes
 */
class EstimatedDeliveryComponent extends Component {
  requiredRefs = ['toggleButton', 'detailsContent'];

  connectedCallback() {
    super.connectedCallback();
    
    // Listen for variant updates
    const closestSection = this.closest('.shopify-section, dialog');
    if (closestSection) {
      closestSection.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    
    const closestSection = this.closest('.shopify-section, dialog');
    if (closestSection) {
      closestSection.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
    }
  }

  /**
   * Handles variant update events
   * @param {VariantUpdateEvent} event - The variant update event
   */
  #handleVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const variant = event.detail.resource;
    if (variant && variant.id) {
      this.dataset.variantId = variant.id;
      
      // Close details if open when variant changes
      if (this.dataset.expanded === 'true') {
        this.toggleDetails();
      }
    }
  };

  /**
   * Toggles the details section visibility
   */
  toggleDetails = () => {
    const { toggleButton, detailsContent } = this.refs;
    if (!toggleButton || !detailsContent) return;

    const container = this.querySelector('.estimated-delivery__container');
    if (!container) return;

    const isExpanded = container.hasAttribute('data-expanded') && container.dataset.expanded === 'true';
    
    if (isExpanded) {
      // Collapse
      detailsContent.hidden = true;
      toggleButton.setAttribute('aria-expanded', 'false');
      container.removeAttribute('data-expanded');
    } else {
      // Expand
      detailsContent.hidden = false;
      toggleButton.setAttribute('aria-expanded', 'true');
      container.setAttribute('data-expanded', 'true');
    }
  };
}

if (!customElements.get('estimated-delivery-component')) {
  customElements.define('estimated-delivery-component', EstimatedDeliveryComponent);
}
